import * as React from 'react';
import * as _ from 'underscore';

import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';

import { StyledCellFormatter } from '../StyledCellWrapper';
import { CommonStyles } from '../../../../common/react/CommonStyles';
import { getLinkMarkup, ILink } from './LinkCell';
import { ICollectionInfo } from '../../Collections/ICollectionInfo';
import { CollectionsPrivateIndicator, CollectionsPrivateIndicatorIdPrefix } from '../../Collections/CollectionsPrivateIndicator';
import { TabStyles } from '@tableau/widgets';
import { cssClass } from '~src/style';
import { generateUniqueId } from '~src/app/utils/DomUtils';

export function LinkWithCollectionVisibility(linkFn: (row: DataGrid.Row) => ILink): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render() {
          const textEllipsis = CommonStyles.Layout.TextEllipsis;
          const shouldDisplayPrivateIndicator = (this.props.row.data as ICollectionInfo).visibility === 'private';
          const privateIndicatorId = shouldDisplayPrivateIndicator ? generateUniqueId(CollectionsPrivateIndicatorIdPrefix) : '';

          const link: ILink = linkFn(this.props.row);
          if (!link) {
            return null;
          }

          return (
            <span data-tb-test-id={link.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {link.displayJustText ?
                <span
                  title={link.hideTooltips ? null : (link.title || link.text)}
                  style={_.extend({display: 'block'}, textEllipsis, link.style)}
                  aria-labelledby={privateIndicatorId}
                >
                  {link.text}
                </span>
                : getLinkMarkup(link, this.props.row, privateIndicatorId)
              }
              {shouldDisplayPrivateIndicator &&
                <span className={PrivateCollectionAreaListView} id={privateIndicatorId}>
                  <CollectionsPrivateIndicator />
                </span>
              }
          </span>
          );
        }
      })
  );
}

const PrivateCollectionAreaListView = cssClass('collections-private-indicator', 'list-view', {
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  fontSize: '12px',
  fontWeight: 'normal'
});
